//* Base64 compatible URL (sans + / =), qui supporte l'UTF-8 des libellés
export const encodeBase64Url = (value: string): string => {
  const utf8 = unescape(encodeURIComponent(value));
  return btoa(utf8).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const decodeBase64Url = (value: string): string => {
  const b64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
  return decodeURIComponent(escape(atob(padded)));
};
